import { Button, Group, Popover, Text } from "@mantine/core";
import { Icon } from "./icons";
import { faExclamationCircle } from "@fortawesome/pro-duotone-svg-icons";
import t from "../stores/language";
import { FloatingPosition } from "@mantine/core/lib/Floating";
import React from "react";
import theme from "../stores/theme";
import { useDisclosure } from "@mantine/hooks";

export interface PopConfirmProps {
  confirmText: string;
  width: number | string;
  position?: FloatingPosition;
  buttonPosition?: "left" | "right";
  children: React.ReactNode;
  onConfirm: () => void;
}

const PopConfirm = function PopConfirm({ width, position, buttonPosition, confirmText, children, onConfirm }: PopConfirmProps) {
  const [isOpen, { close, toggle }] = useDisclosure(false);

  const onOkClick = () => {
    onConfirm();
    close();
  };

  return (
    <Popover withinPortal opened={isOpen} width={width} position={position ?? "top"} withArrow shadow="md" onClose={close}>
      <Popover.Target>
        <div onClick={toggle}>{children}</div>
      </Popover.Target>
      <Popover.Dropdown>
        <Group noWrap={true}>
          <Icon size="lg" color={theme.other?.arc.colors[4]} icon={faExclamationCircle} />
          <Text size={14}>{confirmText}</Text>
        </Group>
        <Group mt={theme.other?.arc.margins[2]} position={buttonPosition ?? "left"}>
          <Button variant={"default"} size="xs" onClick={close}>
            {t("Cancel")}
          </Button>
          <Button size="xs" onClick={onOkClick}>
            {t("Ok")}
          </Button>
        </Group>
      </Popover.Dropdown>
    </Popover>
  );
};

export default PopConfirm;
